// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-BIA","actions":"styles_actions__280Vv","error":"styles_error__yl64p","message":"styles_message__2fg-O"};